import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { components } from '@glowforge/ui-common';

import './terms-and-conditions.less';

const { Button, Checkbox, Markdown } = components;

class TermsAndConditionsScroll extends Component {
  constructor(props) {
    super(props);
    this.state = { scrolledToBottom: false, confirmTermsChecked: false };
  }

  componentDidMount() {
    if (BROWSER) {
      this.scrollArea.addEventListener('scroll', this.onScroll);
    }
  }

  componentWillUnmount() {
    this.scrollArea.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    if (this.scrollArea.scrollTop + this.scrollArea.offsetHeight >= this.scrollArea.scrollHeight) {
      this.setState({ scrolledToBottom: true });
    }
  };

  onConfirmTermsCheck = (value) => {
    this.setState({ confirmTermsChecked: value });
  };

  onAcceptTerms = () => {
    const {
      goToNext,
      terms,
      downloadUrl,
    } = this.props;
    goToNext(_.get(terms, 'minorVersion'), downloadUrl);
  };

  render() {
    let scrollMessage;
    if (this.state.confirmTermsChecked && !this.state.scrolledToBottom) {
      scrollMessage = (
        <div className='scrollReqMessage'>
          Please scroll to the bottom and read all material provided before you agree
        </div>
      );
    }
    let warranty;
    if (this.props.warranty) {
      warranty = [<h1 key='warrantyHeader' className='h1'>{_.get(this.props.warranty, 'title')}</h1>,
        <Markdown key='warrantyContent' className='paragraph' source={_.get(this.props.warranty, 'legalContent')} />];
    }
    return (
      <div className='TermsAndConditionsScroll grow'>
        { this.props.pageTitle && <Helmet title={`Glowforge Setup - ${this.props.pageTitle}`} />}
        <div className='scrollArea' ref={(div) => { this.scrollArea = div; }}>
          <h1 className='h1'>{_.get(this.props.terms, 'title')}</h1>
          <Markdown
            className='termsMarkdown paragraph'
            source={
              `${_.get(this.props.terms, 'legalContent')} ${_.get(this.props.terms, 'legalContentPart2')}`
            } />
          {warranty}
        </div>
        <Checkbox
          name='confirm'
          value={this.state.confirmTermsChecked}
          onChange={this.onConfirmTermsCheck}
          label={this.props.terms.confirmCheckboxText} />
        <div className='actionButton'>
          {scrollMessage}
          <Button
            type='primary'
            size='large'
            disabled={!this.state.confirmTermsChecked || !this.state.scrolledToBottom}
            onClick={this.onAcceptTerms}>
            {this.props.terms.confirmButtonText}
          </Button>
        </div>
      </div>
    );
  }
}

TermsAndConditionsScroll.propTypes = {
  pageTitle: PropTypes.string,
  terms: PropTypes.object.isRequired, // eslint-disable-line
  confirmButtonText: PropTypes.string.isRequired,
  confirmCheckboxText: PropTypes.string.isRequired,
  goToNext: PropTypes.func.isRequired,
  warranty: PropTypes.object, // eslint-disable-line
  downloadUrl: PropTypes.string.isRequired,
};

TermsAndConditionsScroll.defaultProps = {
  subTitle: null,
  pageTitle: null,
  warranty: null,
  features: {},
};

const TermsAndConditions = (props) => {
  const title = props.title ? <h1 className='h1'>{props.title}</h1> : null;
  const subTitle = props.subTitle ? <div className='subTitle'>{props.subTitle}</div> : null;

  return (
    <div className='scrollPage contentPage'>
      {title}
      {subTitle}
      <div className='content grow'>
        <Markdown className='paragraph' source={props.textBlock} />
        <TermsAndConditionsScroll {...props} />
      </div>
    </div>
  );
};

TermsAndConditions.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  textBlock: PropTypes.string,
};

TermsAndConditions.defaultProps = {
  title: null,
  subTitle: null,
  textBlock: null,
};

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./app/common/components/terms-and-conditions.jsx